<script>
  import Auth0Lock from "auth0-lock";
  import queryString from "query-string";
  import { onMount } from "svelte";
  import LogoDarkBlueURL from "../assets/icons/logo-dark-blue.svg";
  import { lock } from "../stores/lock.js";
  import { logout,sessionStatus } from "../utils/api";
  import { getQueryTenantId } from "../utils/queryString";
  import Header from './Header.svelte';

  onMount(async () => {
    const qs = queryString.parse(location.search);
    const forcedTenantId = getQueryTenantId();
    // fl for Force Logout
    if (qs.fl) {
      await logout();
    }

    const isSessionActive = await sessionStatus();
    if (isSessionActive) {
      window.location.assign(`${window.location.origin}/`);
      return;
    }
    let redirectUrl = `${window.location.origin}/welcome/activate`;
    const loginLock = new Auth0Lock(
      process.env.AUTH0__CLIENT_ID,
      process.env.AUTH0__DOMAIN,
      {
        configurationBaseUrl: process.env.AUTH0__CONFIG_BASE_URL || "https://cdn.auth0.com",
        auth: {
          sso: false,
          audience: process.env.AUTH0__AUDIENCE || "",
          redirect: true,
          redirectUrl,
          responseType: "token id_token",
          params: {
            scope: "openid",
            state: qs.next ? JSON.stringify({ next: qs.next, forcedTenantId }) : undefined
          }
        },
        theme: {
          logo: LogoDarkBlueURL,
          hideMainScreenTitle: true,
          primaryColor: "#0081d6"
        },
        languageDictionary: {
          title: "",
          signUpTerms: "",
          loginWithLabel: "Sign In with %s",
          loginSubmitLabel: "Sign In",
          forgotPasswordAction: "Forgot Password?",
          emailInputPlaceholder: "Email Address",
          passwordInputPlaceholder: "Password",
        },
        container: "auth-container",
        rememberLastLogin: true
      }
    );
    loginLock.show({
      allowSignUp: false,
      allowLogin: true
    });
    lock.set(loginLock);
  });
</script>

<div class="container">
  <Header />
  <div class="formContainer">
    <div class="form">
      <h1>Welcome back!</h1>
      <div id="auth-container" />
    </div>
    <div class="requestAccess">
      <span>Don’t have an account?</span>
      <a href="https://www.fireblocks.com/request-access/">Request Access</a>
    </div>
  </div>
</div>

<style>
  .requestAccess {
    font-family: Heebo;
    padding-top: 30px;
  }
</style>
